import { render, staticRenderFns } from "./ContentHeight.vue?vue&type=template&id=24b6e34a&"
import script from "./ContentHeight.vue?vue&type=script&lang=js&"
export * from "./ContentHeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports